module.exports = __webpack_public_path__ + "img/1404.7209a538.jpg";